import React from "react";
import { Layout, Menu, /*Badge,*/ Dropdown, Button } from "antd";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

import MainMenu from "../Menu/Main";

const { Header } = Layout;

const MainHeader = () => {
  const auth = useSelector((state) => state.auth);
  const user = auth.userData;

  return (
    <Header
      className="MainHeader"
      style={{ position: "fixed", zIndex: 9999, width: "100%" }}
    >
      <div className="logo">
        <Link to="/">
          <img
            src={`/logo.svg`}
            alt="logo"
            style={{maxWidth: "100%"}}
          />
        </Link>
      </div>
      <MainMenu />
      <div className="account-info">
        {/* <Badge count={100} overflowCount={99} showZero /> */}
        <div className="avatar">
          <img
            src={`https://ui-avatars.com/api/?length=1&name=${user.name}&size=32&font-size=0.4&bold=true&rounded=true&background=FFC44450&color=FFC444`}
            alt=""
          />
        </div>
        <div className="info">
          <div className="fullname">{user.name}</div>
          <Dropdown
            trigger={["hover"]}
            overlay={
              <Menu>
                <Menu.Item key="logout">
                  <Link to="/logout" className="logout">
                    <Button type="text" size="small">
                      Logga ut
                    </Button>
                  </Link>
                </Menu.Item>
              </Menu>
            }
          >
            <div className="email">
              {user.username} <DownOutlined />
            </div>
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

export default MainHeader;
